import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"embercom-prosemirror-composer-vertical-divider\" data-test-vertical-divider><div class=\"embercom-prosemirror-composer-vertical-divider-inner\"></div></div>", {
  moduleName: "@intercom/embercom-prosemirror-composer/components/utils/vertical-divider.hbs"
});